import { ElementRef } from '@angular/core';
import { Observable, fromEvent, merge } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { Invoice } from '@confirmo/overlay';
import { LandingPath } from '../shared/enums/paths/landing-path.enum';
import { DEMO_INVOICE_LINK } from '../shared/links';

export function isCampaignPage(): boolean {
  return location.href.includes(LandingPath.Campaign);
}

export function loadScriptSrc(src: string, elementRef: ElementRef): Observable<boolean> {
  return new Observable<boolean>((observer) => {
    const script = document.createElement('script');
    script.src = src;
    script.async = true;

    const load$ = fromEvent(script, 'load').pipe(map(() => true));
    const error$ = fromEvent(script, 'error').pipe(map(() => false));

    elementRef.nativeElement.appendChild(script);

    return merge(load$, error$).pipe(take(1)).subscribe(observer);
  });
}

export function openDemoInvoice(): void {
  let listeners: { onScroll: () => void; onResize: () => void };
  const callbackFunction = () => removeWarningBannerForDemoInvoice(listeners?.onScroll, listeners?.onResize);

  Invoice.open(DEMO_INVOICE_LINK, callbackFunction);
  listeners = addWarningBannerForDemoInvoice();
}

function addWarningBannerForDemoInvoice(): { onScroll: () => void; onResize: () => void } {
  const overlay = document.querySelector('.overlay-container') as HTMLElement | null;
  const invoiceBox = document.querySelector('.invoice-box') as HTMLElement | null;
  const invoiceBoxInner = document.querySelector('.invoice-box__inner') as HTMLElement | null;

  let onScroll: () => void;
  let onResize: () => void;

  if (overlay && invoiceBox && invoiceBoxInner) {
    const bannerDiv = document.createElement('div');
    bannerDiv.className = 'demo-payment-warning-banner';
    bannerDiv.innerHTML = `
      <p class="demo-payment-warning-banner__text">
        <strong>DO NOT PAY!</strong> Sent funds will be lost.
      </p>`;
    overlay.appendChild(bannerDiv);

    const updateBannerPosition = () => updateBannerTopAndWidth(invoiceBox, invoiceBoxInner, bannerDiv);

    onScroll = updateBannerPosition;
    onResize = updateBannerPosition;

    window.addEventListener('scroll', onScroll);
    window.addEventListener('resize', onResize);

    updateBannerPosition();
  }

  return { onScroll, onResize };
}

function updateBannerTopAndWidth(invoiceBox: HTMLElement, invoiceBoxInner: HTMLElement, bannerDiv: HTMLElement): void {
  const invoiceBoxRect = invoiceBox.getBoundingClientRect();
  const invoiceBoxInnerRect = invoiceBoxInner.getBoundingClientRect();

  //move the banner on top of the Overlay popup
  if (window.innerWidth >= 480) {
    bannerDiv.style.top = `${invoiceBoxRect.top - 45}px`;
    invoiceBox.style.marginTop = `0`;
  } else {
    bannerDiv.style.top = `0`;
    invoiceBox.style.marginTop = `80px`;
  }
  bannerDiv.style.width = `${invoiceBoxInnerRect.width}px`;
}

function removeWarningBannerForDemoInvoice(onScroll: () => void, onResize: () => void): () => void {
  window.removeEventListener('scroll', onScroll);
  window.removeEventListener('resize', onResize);
  return () => {};
}
